import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateDockCompanyActions as Actions,
  CreateDockCompanyRequestAction as RequestAction,
} from 'store/ducks/dockCompanies';

export function* createDockCompanyRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `dock-companies`, postData);
    onSuccess && onSuccess();
    notify('success', 'Cliente vinculado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
